import React from "react";
import clsx from "clsx";
import { makeStyles } from '@mui/styles';
import { AppBar, Badge, Toolbar, Menu, MenuItem, IconButton, Typography, Tooltip } from "@mui/material";

import MoreVertIcon from '@mui/icons-material/MoreVert';
import MenuIcon from '@mui/icons-material/Menu';
import EmailIcon from '@mui/icons-material/Email';
import NotificationsIcon from '@mui/icons-material/Notifications';


const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  hide: {
    display: "none",
  },
}));

const messageCount = 0;
const notificationCount = 0;


const Header = (props) => {

  const { handleDrawerOpen,open } = props;
  const classes = useStyles();
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >

      <MenuItem>
        <IconButton aria-label="messages" sx={{color: 'background.paper',}}>
          <Badge badgeContent={messageCount} color="secondary">
            <EmailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton aria-label="notifications" sx={{color: 'background.paper',}}>
          <Badge badgeContent={notificationCount} color="secondary">
            <NotificationsIcon/>
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
    </Menu>
  );

  return (
    <React.Fragment>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <Tooltip title="open navigation menu" arrow>
            <IconButton
              color="inherit"
              aria-label="navigation menu"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, open && classes.hide)}
            >
                <MenuIcon />
            </IconButton>
          </Tooltip>
          <Typography variant="h1">{props.toolBarTitle}</Typography>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>

            <Tooltip title="view messages" arrow>
              <IconButton href="/messages" aria-label="messages">
                <Badge badgeContent={messageCount} color="secondary" >
                  <EmailIcon title="view messages" sx={{color: 'background.paper'}} />
                </Badge>
              </IconButton>
            </Tooltip>
            <Tooltip title="view notifications" arrow>
              <IconButton href="/notifications" aria-label="notifications">
                <Badge badgeContent={notificationCount} color="secondary">
                  <NotificationsIcon title="view notifications"  sx={{color: 'background.paper'}}/>
                </Badge>
              </IconButton>
            </Tooltip>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreVertIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
    </React.Fragment>
  );
}

export default Header;

Header.defaultProps = {
  toolBarTitle: 'Centric'
};
